import { Loader } from "samespace-zen";

export const LoaderWrapper = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <Loader />
    </div>
  );
};
